import { Box, IconButton, Typography } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import {Thread } from "../../../types/data";
import { FC } from "react";

export const ThreadSummaryItem: FC<
	Thread & {
		setCurrentThread: (threadId: number) => void;
	}
> = ({ id, esr_id, subject, messages, resolved, unread_messages, question_id, creator_id, addendum_id, addendum_label, setCurrentThread }) => {

	const selectThread = () => {
		setCurrentThread(id);
	};
	return (
		<Box
			sx={{
				boxSizing: "border-box",
				p: "16px 24px",
				cursor: "pointer",
				transition: "0.2s all",
				"&:hover": {
					background: "#eeeeee",
				},
			}}
			onClick={selectThread}
		>
			{
				question_id !== null &&
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
					}}
				>
				</Box>
			}

			
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center", minWidth: 0, flex: 1 }}>
				{addendum_label.length > 0 ? (
				<Typography
					component="span"
					fontSize={14}
					fontWeight={500}
					my="8px"
					sx={{ color: "green", ml: 0, mr: 1 }}
				>
					ESR#{addendum_id}{addendum_label} 
				</Typography>
				) : (
				<Typography
					component="span"
					fontSize={14}
					fontWeight={500}
					my="8px"
					sx={{ color: "green", ml: 0, mr: 1 }}
				>
					ESR#{esr_id}
				</Typography>
				)}
				<Typography
					fontSize={14}
					fontWeight={500}
					my="8px"
					noWrap
					sx={{
						minWidth: 0,
						overflow: "hidden",
						textOverflow: "ellipsis",
						whiteSpace: "nowrap",
						flex: "1 1 auto",
					}}
				>
					{subject}
				</Typography>
			</Box>
				<ChevronRight />
		</Box>

			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Typography fontSize={12} fontWeight={400} color="#73767d">
					 From: {creator_id}
				</Typography>
			</Box>
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
				<Typography fontSize={12} fontWeight={400} color="#0000004D">
					{messages.length} comments
				</Typography>
				{unread_messages !== 0 &&
					<Typography fontSize={12} fontWeight={400} color="#F72A2A" sx={{ marginLeft: "10%" }}>{unread_messages} unread message(s)</Typography>
				}
			</Box>
		</Box>
	);
};
